import { useQuery } from "@tanstack/react-query";

import { FETCH_ERROR } from "../consts/fetch-error";
import { getPerson, getPersons } from "../services/person";

export function useGetPersons() {
  return useQuery({
    queryKey: ["persons"],
    queryFn: () => getPersons(),
    staleTime: 1000 * 60 * 60, // 1 hour
    retry: (_failureCount, error: unknown) =>
      error !== FETCH_ERROR.UNAUTHORIZED,
  });
}

export function useGetPerson(id: string) {
  return useQuery({
    queryKey: ["person", id],
    queryFn: () => getPerson(id),
    retry: (_failureCount, error: unknown) =>
      error !== FETCH_ERROR.UNAUTHORIZED,
  });
}
